import React from 'react';
import { Route} from 'react-router-dom'
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { TableGenericViewControllerDelegate, TableGenericViewController } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { PropertyConfigViewControllerDelegate, PropertyConfigViewController } from '../../Screen/PropertyConfig/PropertyConfigViewController';
import { PropertyConfigViewModel } from '../../Screen/PropertyConfig/PropertyConfigViewModel';
import { TableGenericFilter } from '../TableGeneric/TableGenericInteractor';
import ProtectedRoute from '../../Components/ProtectedRoute';

export class PropertyConfigCoordinator implements IndexCoordinatorDelegate, TableGenericViewControllerDelegate, PropertyConfigViewControllerDelegate {
    
    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("geppropriedadeconfiguracao")
        return (<ProtectedRoute requiredPermissions={['prop.config.*']} path="/:base/propriedade-configuracao" exact={true} component={(props: any) => {
            var filter = new TableGenericFilter('Origem', 'C', '!=')
            return (<TableGenericViewController 
                permissions={{
                    add: 'prop.config.adicionar',
                    edit: 'prop.config.editar',
                    delete: 'prop.config.excluir',
                }}
                navigation={props} 
                viewModel={viewModel} 
                delegate={this} 
                title={"Configuração Propriedade"}
                filter={[filter]}
            />)
        }}/>)
    }

    private routeForm(): JSX.Element {
        var viewModel = new PropertyConfigViewModel()
        return (<ProtectedRoute requiredPermissions={['prop.config.adicionar', 'prop.config.editar']} path="/:base/propriedade-configuracao/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<PropertyConfigViewController 
                navigation={props} 
                viewModel={viewModel} 
                delegate={this} 
                idPrimary={idPk}
                title={"Configuração Propriedade"}
            />)
        }}/>)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }
    
    add(navigation: any, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "geppropriedadeconfiguracao") {
            navigation.history.push(`propriedade-configuracao/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "geppropriedadeconfiguracao") {
            navigation.history.push(`propriedade-configuracao/cad/${idSelection}`);
            return;
        }
    }

}